import React from "react";
import PropTypes from "prop-types";
import { ResponsiveImage, ResponsiveSource } from "@quintype/components";
import VikatanStoryFallback from "../../shared/icons/fallbackImage";
import { PremiumBadge } from "../../atoms/premium-badge";
import { omit, get } from "lodash";
import { MyVikatanBadge } from "../my-vikatan-badge";
import { MyVikatanBadgeArticle } from "../my-vikatan-badge-article";
import { MyVikatanBadgeSmall } from "../my-vikatan-badge-small";

const ResponsiveImageWithFallback = ({
  className,
  story,
  children,
  sources,
  zoom = true,
  style,
  isPremium,
  cardType,
  ...props
}) => {
  const cluster = get(story, ["metadata", "story-attributes", "cluster", "0"], "");
  let responsiveSources = [];
  let image = null;
  let originalSources = [...sources];
  if (sources && sources.length) {
    responsiveSources = originalSources
      .slice(0, -1)
      .map((source, index) => <ResponsiveSource key={index} {...omit(props, ["alt"])} {...source} />);
    image = originalSources[originalSources.length - 1];
  }
  return (
    <React.Fragment>
      <figure className={`${className} qt-figure myvikatan-wrapper`} style={style}>
        {props.slug ? (
          <picture className={`qt-image ${zoom ? "zoom-desktop" : ""}`}>
            {responsiveSources.length ? responsiveSources : null}
            <ResponsiveImage {...props} {...image} />
          </picture>
        ) : (
          <picture className={`qt-image ${zoom ? "zoom-desktop" : ""}`}>
            <VikatanStoryFallback />
          </picture>
        )}

        {children}
        <PremiumBadge isPremium={isPremium} />
        {cardType === "hero-banner" ? (
          <MyVikatanBadgeArticle isMyVikatan={cluster === "MyVikatan"} />
        ) : cardType === "small-card" ? (
          <MyVikatanBadgeSmall isMyVikatan={cluster === "MyVikatan"} />
        ) : (
          <MyVikatanBadge isMyVikatan={cluster === "MyVikatan"} />
        )}
      </figure>
    </React.Fragment>
  );
};

ResponsiveImageWithFallback.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  zoom: PropTypes.bool,
  sources: PropTypes.arrayOf(PropTypes.object)
};

export default ResponsiveImageWithFallback;
